module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoLayout mainLayout"
  }, [_c('section', {
    staticClass: "info"
  }, [_c('h1', [_vm._v("Cookie Policy")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "info-tech"
    }
  }, [_vm._v("Cookie")]), _vm._v(" "), _c('p', [_vm._v("I cookie piccoli file di testo salvati sul device dell'utente. Solitamente mantengono dati sulle sessioni.")]), _vm._v(" "), _c('h2', [_vm._v("Utilizzo di cookie per il sito web")]), _vm._v(" "), _c('p', [_vm._v("Sul sito attuale i cookie sono usati da Firebase per mantenere i dati di sessione e per permettere a Google il corretto funzionamento dell'applicazione, ad esempio fornirvi l'elenco dei video aggiornati.")]), _vm._v(" "), _c('h2', [_vm._v("Come disattivare i cookie")]), _vm._v(" "), _c('p', [_vm._v("Seguendo le indicazioni qui presenti sara' facile disattivare i cookie, tuttavia cosi' facendo probabilmente non sara' possibile utilizzare questo sito:\n\t\t\t"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wikihow.it/Disattivare-i-Cookies",
      "target": "_blank"
    }
  }, [_vm._v("https://www.wikihow.it/Disattivare-i-Cookies")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2d26b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookie-info.vue
// module id = 241
// module chunks = 4